export default "__VITE_ASSET__hdT$mFw___"